<template>
    <v-card>
        <v-card-title primary-title>
            <v-img class="white--text" height="100px" :src="getImageUrl('oblo/corridoio 3.jpeg')">
                <v-container fill-height fluid>
                    <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                            <span class="headline">{{$t("book.bookingTitle")}}</span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-img>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <!-- IN -->
                <v-flex xs12 sm12 md12 lg12>
                    <v-dialog ref="dialogIn" v-model="dateInModal" :return-value.sync="book.dateIn" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="book.dateIn" :label="$t('book.dateIn')" prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="book.dateIn" scrollable @input="updateDateOut()">
                            <v-spacer></v-spacer>
                            <v-btn flat color="success" @click="dateInModal = false">Cancel</v-btn>
                            <v-btn color="success" @click="$refs.dialogIn.save(book.dateIn)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <!-- OUT -->
                <v-flex xs12 sm12 md12 lg12>
                    <v-dialog ref="dialogOut" v-model="dateOutModal" :return-value.sync="book.dateOut" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="book.dateOut" :label="$t('book.dateOut')" prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="book.dateOut" scrollable :reactive="true">
                            <v-spacer></v-spacer>
                            <v-btn flat color="success" @click="dateOutModal = false">Cancel</v-btn>
                            <v-btn color="success" @click="$refs.dialogOut.save(book.dateOut)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <!-- <v-flex xs12 sm12 md12 lg2 class="px-3">
                    <v-text-field name="nights" v-model="book.nights" :label="$t('book.nights')" id="nights-txt" type="number"></v-text-field>
                </v-flex> -->
            </v-layout>

            <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg6 class="px-3">
                    <v-text-field name="adults" v-model="book.adults" :label="$t('book.adults')" id="adults-txt" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 class="px-3">
                    <v-text-field name="kids" v-model="book.kids" :label="$t('book.kids')" id="kids-txt" type="number"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!confirm" @click="$emit('open-dialog')">{{$t("book.confirm_book")}}</v-btn>
            <v-btn :loading="loading" :disabled="loading" color="obloyellow" outline @click="search()">
                {{$t("book.search")}}
                <template v-slot:loader>
                    <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                    </span>
                </template>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        confirm: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data(){
        return{
            book: {
                dateIn: new Date().toISOString().substr(0, 10),
                dateOut: new Date().toISOString().substr(0, 10),
                nights: 1,
                adults: 1,
                kids: 0
            },
            dateInModal: false,
            dateOutModal: false,
            loader: null
        }
    },
    mounted(){
        this.updateDateOut();
    },
    methods: {
        search(){
            this.loader = 'loading';
            this.$emit("search-booking", this.book);
        },
        updateDateOut(){
            // Add one day
            let tmp = new Date(this.book.dateIn);
            tmp.setDate(tmp.getDate() + 1);
            
            this.book.dateOut = tmp.toISOString().substr(0, 10);
        },
        getImageUrl: function(image){
            return require(`../../../assets/img/${image}`);
        }
    }
}
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>